import { createStyles, makeStyles, Theme } from '@material-ui/core';

export const useStyles = makeStyles((theme: Theme) => {
  return createStyles({
    /* 検索窓のレイアウト調整 */
    searchContainer: {
      marginBottom: '16px'
    },
    searchPeriodWrapper: {
      display: 'inline-block',
      width: '330px',
      marginRight: '16px',
      verticalAlign: 'top',
      overflow: 'visible',
      whiteSpace: 'nowrap'
    },
    displaySwitchWrapper: {
      display: 'inline-block',
      verticalAlign: 'top'
    },
    waveDash: {
      textAlign: 'center',
      display: 'inline-block',
      paddingRight: '8px',
      paddingLeft: '8px'
    },
    dateInput: {
      width: '145px'
    },
    noDataMesage: {
      textAlign: 'center',
      padding: '32px'
    },
    checkBoxLabel: {
      fontSize: '14px'
    },
    helperText: {
      color: '#F44336',
      fontSize: '0.75rem',
      position: 'relative',
      top: '-6px',
      marginTop: '16px',
      marginLeft: '16px',
      marginRight: '16px',
      fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif;'
    },
    addProcessButton: {
      fontSize: '8px',
      padding: '4px',
      minWidth: '24px',
      color: '#fff',
      background: '#007dff'
    },
    statusSelectBox: {
      border: 1,
      borderStyle: 'solid',
      borderColor: '#758283',
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      borderRadius: 5,
      overflow: 'hidden'
    },
    statusSelectBoxInRow: {
      backgroundColor: '#FFFFFF',
      fontSize: '0.9em',
      paddingLeft: '5px',
      paddingRight: '5px',
      minWidth: '90px'
    }
  });
});
